// BlurView shim covering both `expo-blur` and `@react-native-community/blur`.
// Renders a plain View — visual blur is dropped on web. The host SDK
// uses blur for non-critical overlays (modal backdrops, tab-bar
// translucency); rendering a View keeps the layout intact without the
// blur effect.
import type { FC, ReactNode } from 'react';
import { View, type ViewProps } from 'react-native';

interface BlurViewProps extends ViewProps {
  intensity?: number;
  tint?: string;
  experimentalBlurMethod?: string;
  blurType?: string;
  blurAmount?: number;
  reducedTransparencyFallbackColor?: string;
  children?: ReactNode;
}

const BlurView: FC<BlurViewProps> = ({ children, style, ...rest }) => (
  <View style={style} {...rest}>
    {children}
  </View>
);

export default BlurView;
export { BlurView };
